export const isExcludeMode = (predicate)=>{
    var _ref;
    var _predicate_nin;
    return ((_ref = (_predicate_nin = predicate.nin) === null || _predicate_nin === void 0 ? void 0 : _predicate_nin.length) !== null && _ref !== void 0 ? _ref : 0) > 0;
};
export const activeValues = (predicate)=>{
    var _predicate_nin, _predicate_in;
    return isExcludeMode(predicate) ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [];
};
export const valueLabelFor = (options, predicate, fallback)=>{
    const values = activeValues(predicate);
    if (values.length === 0) return fallback;
    return values.map((value)=>{
        var _ref;
        var _options_find;
        return (_ref = (_options_find = options.find((option)=>option.value === value)) === null || _options_find === void 0 ? void 0 : _options_find.label) !== null && _ref !== void 0 ? _ref : value;
    }).join(', ');
};
